export const mergeOrgIdsIntoOrgNodeIds = (
  orgIds?: string,
  orgNodeIds?: string,
) => {
  let mergedOrgNodeIds = orgNodeIds || "";
  if (orgIds) {
    const orgNodeIdsArr = orgNodeIds ? orgNodeIds.split(",") : [];
    const orgIdsArr = orgIds ? orgIds.split(",") : [];
    mergedOrgNodeIds = Array.from(new Set([...orgNodeIdsArr, ...orgIdsArr]))
      .filter(Boolean)
      .join(",");
  }
  return mergedOrgNodeIds;
};

export const normalizeSavePayloadRecursively = (value: any): any => {
  if (Array.isArray(value)) {
    return value.map(normalizeSavePayloadRecursively);
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  const normalized: any = { ...value };

  if ("org_ids" in normalized || "org_node_ids" in normalized) {
    normalized.org_node_ids = mergeOrgIdsIntoOrgNodeIds(
      normalized.org_ids,
      normalized.org_node_ids,
    );
    normalized.org_ids = "";
  }

  Object.keys(normalized).forEach((key) => {
    normalized[key] = normalizeSavePayloadRecursively(normalized[key]);
  });

  return normalized;
};
